<div class="loading-screen-wrapper" [hidden]="!loading">
  <mat-spinner></mat-spinner>
</div>
